import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent {

  constructor(private router: Router) { }

  /**
   * Navigates the user back to the login page.
   */
  login() {
    this.router.navigate(['welcome'], { queryParamsHandling: 'preserve' });
  }
}
